import React, { Component } from 'react'
import './styles.css'

export default class Checkbox extends Component {
  render () {
    const { children, disabled = false, feedback = false, defaultChecked = undefined, checked = undefined, onClick = null } = this.props
    const properties = { ...this.props }
    delete properties.feedback
    delete properties.defaultValue
    delete properties.onClick
    delete properties.className

    return (
      <label className='check-container' {...properties}>
        <input
          type='checkbox'
          defaultChecked={defaultChecked}
          checked={checked}
          onClick={onClick}
          disabled={disabled}
        />
        <span className='checkmark' />
      </label>
    )
  }
}
